 const firebaseConfig = {
  apiKey: "AIzaSyACqg6sN4ju2Nrzwmr4w7suxmWpunReDuQ",
  authDomain: "online-doctors-portal.firebaseapp.com",
  projectId: "online-doctors-portal",
  storageBucket: "online-doctors-portal.appspot.com",
  messagingSenderId: "86203640007",
  appId: "1:86203640007:web:09c1cef7f7851d8e7676e2"
  };

export default firebaseConfig;